import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import BranchmasterViewPage from 'pages/branchmaster/View';
import MembermasterViewPage from 'pages/membermaster/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const SavingsmasterListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/savingsmaster/view/${data.accountnumber}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('savingsmaster/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/savingsmaster/edit/${data.accountnumber}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('savingsmaster/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.accountnumber) },
			icon: "pi pi-trash",
			visible: () => auth.canView('savingsmaster/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function AccountnumberTemplate(data){
		if(data){
			return (
				<Link to={`/savingsmaster/view/${data.accountnumber}`}> { data.accountnumber }</Link>
			);
		}
	}
	function MemberidTemplate(data){
		if(data){
			return (
				<>{data.memberid && <Button className="p-button-text" icon="pi pi-eye" label={$t('membermaster')} onClick={() => app.openPageDialog(<MembermasterViewPage isSubPage apiPath={`/membermaster/view/${data.memberid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function EmailidTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.emailid}`}>{ data.emailid }</a>
			);
		}
	}
	function BranchcodeTemplate(data){
		if(data){
			return (
				<>{data.branchcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('branchmaster')} onClick={() => app.openPageDialog(<BranchmasterViewPage isSubPage apiPath={`/branchmaster/view/${data.branchcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function SignatureImageTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.signature_image} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function PhotoImageTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.photo_image} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-savingsmaster`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">{$t('records')} <b>{ recordsPosition } {$t('of')} { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="savingsmaster/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="SavingsmasterListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('savingsmaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/savingsmaster/add`}>
                            <Button label={$t('addNewSavingsmaster')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="grid ">
                                <div className="col">
                                    <div className="page-records">
                                        <DataTable 
                                            lazy={true} 
                                            loading={loading} 
                                            selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                            value={records} 
                                            dataKey="accountnumber" 
                                            sortField={sortBy} 
                                            sortOrder={sortOrder} 
                                            onSort={onSort}
                                            className=" p-datatable-sm" 
                                            stripedRows={true}
                                            showGridlines={false} 
                                            rowHover={true} 
                                            responsiveLayout="stack" 
                                            emptyMessage={<EmptyRecordMessage />} 
                                            >
                                            {/*PageComponentStart*/}
                                            <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                            <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                            <Column  field="accountnumber" header={$t('accountnumber')} body={AccountnumberTemplate} sortable={true} ></Column>
                                            <Column  field="memberid" header={$t('memberid')} body={MemberidTemplate} sortable={true} ></Column>
                                            <Column  field="membername" header={$t('membername')}  sortable={true} ></Column>
                                            <Column  field="accountopen_date" header={$t('accountopenDate')}  sortable={true} ></Column>
                                            <Column  field="documents_ok" header={$t('documentsOk')}  sortable={true} ></Column>
                                            <Column  field="mobile" header={$t('mobile')}  sortable={true} ></Column>
                                            <Column  field="emailid" header={$t('emailid')} body={EmailidTemplate} sortable={true} ></Column>
                                            <Column  field="branchcode" header={$t('branchcode')} body={BranchcodeTemplate} sortable={true} ></Column>
                                            <Column  field="empcode" header={$t('empcode')}  sortable={true} ></Column>
                                            <Column  field="signature_image" header={$t('signatureImage')} body={SignatureImageTemplate} sortable={true} ></Column>
                                            <Column  field="photo_image" header={$t('photoImage')} body={PhotoImageTemplate} sortable={true} ></Column>
                                            <Column  field="created_by" header={$t('createdBy')}  sortable={true} ></Column>
                                            <Column  field="created_at" header={$t('createdAt')}  sortable={true} ></Column>
                                            <Column  field="updated_at" header={$t('updatedAt')}  sortable={true} ></Column>
                                            <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                            {/*PageComponentEnd*/}
                                        </DataTable>
                                    </div>
                                    <PageFooter />
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card p-0">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
SavingsmasterListPage.defaultProps = {
	primaryKey: 'accountnumber',
	pageName: 'savingsmaster',
	apiPath: 'savingsmaster/index',
	routeName: 'savingsmasterlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default SavingsmasterListPage;
